import { TachographTimeline } from "../models/Tachograph";
import { DAY_MS, formatUtcDateTime } from "./tachographDates";
import { formatDate } from "@/hooks/metrics/useFormattedDate";

type TranslateCount = (key: string, options: { count: number }) => string;

/**
 * Builds the deadline texts from the last readout: when the next one is due,
 * in local time and in UTC, plus how many days are left or missed.
 */
export function buildTimeline(
  referenceDate: Date | null,
  updateDate: Date | null,
  intervalDays: number,
  language: string,
  now: Date,
  t: TranslateCount,
): TachographTimeline {
  if (!referenceDate) {
    return {
      legalLimit: "",
      nextDownloadUtc: "",
      dueDate: null,
      updateDate,
    };
  }

  const dueDate = new Date(referenceDate.getTime() + intervalDays * DAY_MS);
  const diffMs = dueDate.getTime() - now.getTime();
  const isDue = diffMs >= 0;
  const count = isDue
    ? Math.floor(diffMs / DAY_MS)
    : Math.abs(Math.ceil(diffMs / DAY_MS));

  const dueLabel = isDue
    ? t("tachograph.daysLeft", { count })
    : t("tachograph.daysOverdue", { count });
  const utcLabel = isDue
    ? t("tachograph.scheduledIn", { count })
    : t("tachograph.overdueBy", { count });

  return {
    legalLimit: `${formatDate(dueDate, language)} | ${dueLabel}`,
    nextDownloadUtc: `${formatUtcDateTime(dueDate)} | ${utcLabel}`,
    dueDate,
    updateDate,
  };
}
